import {
    GET_GROUPS,
    ADD_SELECTED_GROUP,
    CLOSE_MODIFY_POPUP_GROUP,
    OPEN_MODIFY_POPUP_GROUP,
    OPEN_ADD_ACCOUNT_POPUP_GROUP,
    CLOSE_ADD_ACCOUNT_POPUP_GROUP,
    RELOAD_SELECTED_GROUP,
    SET_DATA_SYNC_GROUP,
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
    dataGroups: [],
    selectedGroup: [],
    isOpenModifyPopupGroup: false,
    isOpenAddAccountPopupGroup: false,
    isLoaded: false,
    syncGroups: {
        totalGroup: 0,
        indexAccount: 0,
        totalAccount: 0,
        indexGroup: 0
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_GROUPS: {
            return {
                ...state,
                dataGroups: action.payload,
                isLoaded: true
            };
        }
        case ADD_SELECTED_GROUP: {
            return {
                ...state,
                selectedGroup: action.payload,
            };
        }
        case RELOAD_SELECTED_GROUP: {
            return {
                ...state,
                selectedGroup: []
            }
        }
        case OPEN_MODIFY_POPUP_GROUP: {
            return {
                ...state,
                isOpenModifyPopupGroup: true,
            };
        }
        case CLOSE_MODIFY_POPUP_GROUP: {
            return {
                ...state,
                isOpenModifyPopupGroup: false,
            };
        }
        case OPEN_ADD_ACCOUNT_POPUP_GROUP: {
            return {
                ...state,
                isOpenAddAccountPopupGroup: true,
            };
        }
        case CLOSE_ADD_ACCOUNT_POPUP_GROUP: {
            return {
                ...state,
                isOpenAddAccountPopupGroup: false,
            };
        }
        case SET_DATA_SYNC_GROUP: {
            return {
                ...state,
                syncGroups: {
                    ...state.syncGroups,
                    ...action.payload
                }
            }
        }
        default:
            return state;
    }
};
